import React from 'react';
import { Schema } from './components/Schema';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { TrustStrip } from './components/TrustStrip';
import { AEOAnswerHub } from './components/AEOAnswerHub';
import { ServiceSelector } from './components/ServiceSelector';
import { InstallationStandard } from './components/InstallationStandard';
import { Reviews } from './components/Reviews';
import { PricingCalculator } from './components/PricingCalculator';
import { WhyLangler } from './components/WhyLangler';
import { Process } from './components/Process';
import { ComparisonTable } from './components/ComparisonTable';
import { InstallGallery } from './components/InstallGallery';
import { Brands } from './components/Brands';
import { SmartZone } from './components/SmartZone';
import { Commercial } from './components/Commercial';
import { SuburbsMap } from './components/SuburbsMap';
import { FAQ } from './components/FAQ';
import { QuoteForm } from './components/QuoteForm';
import { TopicalAuthority } from './components/TopicalAuthority';
import { Footer } from './components/Footer';
import { MobileStickyCTA } from './components/MobileStickyCTA';
import { ScrollQuoteBar } from './components/ScrollQuoteBar';
export function App() {
  return <div className="min-h-screen flex flex-col bg-cream text-ink-900 font-sans" data-id="element-0" data-mp="5yhupa6n3cr">
      <a href="#main" className="skip-link" data-id="element-1" data-mp="82ohezguggq">
        Skip to content
      </a>
      <Schema data-id="element-2" data-mp="2zmo89g6xiz5t" />
      <Header data-id="element-3" data-mp="2zn6cayzu2hoa" />
      <ScrollQuoteBar data-id="element-4" data-mp="33mouvo46mgny" />

      <main id="main" className="flex-grow pb-20 lg:pb-0" data-id="element-5" data-mp="33m5e4aq9pybi">
        {/* Hero with embedded form: cold to warm intent capture */}
        <Hero data-id="element-6" data-mp="38l00tnrcw70w" />

        {/* Live credibility numbers (no fabricated counts) */}
        <TrustStrip data-id="element-7" data-mp="3dlw6o6v9q38y" />

        {/* AEO Answer Hub: AI Overviews / ChatGPT / Perplexity extraction surface */}
        <AEOAnswerHub data-id="element-8" data-mp="nur6s1se0axv" />

        {/* Service router: which path are you on */}
        <ServiceSelector data-id="element-9" data-mp="stuexv3nyxa2" />

        {/* Company-led installation standard and risk reversal */}
        <InstallationStandard data-id="element-10" data-mp="35ymodf6r9ya" />

        {/* Social proof: 6 Google review summaries */}
        <Reviews data-id="element-11" data-mp="3ud1dv4v0xg8i" />

        {/* Pricing transparency: kills cost anxiety */}
        <PricingCalculator data-id="element-12" data-mp="3uf5g7id9y76o" />

        {/* Six differentiators in 2x3 grid */}
        <WhyLangler data-id="element-13" data-mp="d3wax0x1p6qw" />

        {/* Four step process timeline */}
        <Process data-id="element-14" data-mp="86mev2f5hwu3" />

        {/* Honest comparison vs wholesalers and discount installers */}
        <ComparisonTable data-id="element-15" data-mp="3gklce8hrtq9p" />

        {/* Real Perth install gallery */}
        <InstallGallery data-id="element-16" data-mp="3bmbazg5gdtfn" />

        {/* Brand authority strip */}
        <Brands data-id="element-17" data-mp="3bo4kd37garrc" />

        {/* Smart Zone iZone cross sell */}
        <SmartZone data-id="element-18" data-mp="3qbg07hao0xx9" />

        {/* Commercial HVAC segment */}
        <Commercial data-id="element-19" data-mp="3lkhdnzz333lk" />

        {/* Local suburb coverage */}
        <SuburbsMap data-id="element-20" data-mp="3liwl2fwbxuqc" />

        {/* FAQ accordion: final objection killer */}
        <FAQ data-id="element-21" data-mp="2xtv6sc0tfpd5" />

        {/* Final commitment form with testimonial sidebar */}
        <QuoteForm data-id="element-22" data-mp="2swbs5b07hako" />

        {/* Topical authority hub: internal link surface for SEO + GEO */}
        <TopicalAuthority data-id="element-23" data-mp="18d9ds8p0zot8" />
      </main>

      <Footer data-id="element-24" data-mp="18c6ou6b9jwfy" />
      <MobileStickyCTA data-id="element-25" data-mp="18cgc3m4xbphy" />
    </div>;
}